import axios from 'axios';
import { CUSTOMER_API_URL } from '../constants';
import { AlternativeProductsApiResponseType } from '../types/api/AlternativeProductsApiType';

export async function getAlternativeProducts(token: string, sellingPlanId: string, page?: number) : Promise<AlternativeProductsApiResponseType> {
	const response = await axios.post<AlternativeProductsApiResponseType>(
		`${CUSTOMER_API_URL}?action=getAlternativeProducts`,
		{ sellingPlanId, page },
		{ headers: { Authorization: token } }
	);
	return response.data;
}